import { wom } from "@Webapp-Clients/Wom"
import { privilege } from "@Webapp-Clients/PRVL"
import { sandbox } from "@Webapp-Clients/Sbx"

export const clients = {
  wom,
  privilege,
  sandbox,
}
